import { useState, useEffect, useRef, forwardRef } from 'react'
import classes from './ArticleNav.module.scss'
import { useHeaderContext } from '@/context/HeaderContext'

const ArticleNav = forwardRef(({}, ref) => {

  const [activeTab, setActiveTab] = useState(Object.keys(ref.current)[0])
  const [scroll, setScroll] = useState(null)
  const navRef = useRef()
  const { hide, headerRef } = useHeaderContext()

  useEffect(() => {
    import('react-scroll').then((module) => {
      setScroll(module.animateScroll)
    })
  }, [])

  const getScrollPosition = (el) => {
    const navRefHeight = navRef.current.offsetHeight + 20
    return el.getBoundingClientRect().top + (
      typeof window !== 'undefined' ? window.scrollY : 0
    ) - navRefHeight
  }

  const onClick = (value) => {
    if (!scroll) return
    const sectionEl = ref.current[`${value}`].current
    const sectionElTopPosition = getScrollPosition(sectionEl)
    scroll.scrollTo(sectionElTopPosition, {
      duration: 300,
    })
  }

  const onScroll = () => {
    const getActiveTab = Object.keys(ref.current).reduce((carry, key) => {
      const tab = ref.current[key].current
      const tabTopPosition = getScrollPosition(tab)
      if (
        typeof window !== 'undefined' &&
        window.pageYOffset + 1 >= tabTopPosition
      )
        return key
      return carry
    }, Object.keys(ref.current)[0])
    setActiveTab(getActiveTab)
  }

  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener('scroll', onScroll)
    }
    return () => {
      if (window !== undefined) {
        window.removeEventListener('scroll', onScroll)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div ref={navRef} className={classes['article-nav']} style={{'top': `${ hide ? 0 : headerRef.current?.offsetHeight}px`}}>
      <ul className={classes['article-nav-list']}>
        {Object.keys(ref.current).map((item, index) => {
          return <li key={index} className={activeTab === item ? classes['is-active'] : ''}><button onClick={() => onClick(item)}>{item}</button></li>
        })}
      </ul>
    </div>
  )
})

export default ArticleNav